import React, {useState,  useEffect} from "react";
import type {EmotionCache} from '@emotion/cache';
import type {AppProps} from 'next/app';
import Head from 'next/head';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {SerwistProvider} from "@serwist/turbopack/react";
import _ from 'lodash';

import '../styles/fonts/fonts.scss';
import '../styles/global.css';
import "../styles/mediaPicker.scss";
import '@fontsource-variable/inter';

import '@isudio/utils';
import '@isudio/utils/lodash/mixins';

import {AppProviders} from '../providers/AppProviders';
import {setupStore} from '@isudio/globals';
// import {pages} from "@isudio/config";
import {LoadingSpinner, Menu} from '@isudio/ui';
// import {LoadingSpinner, Menu, splinePreload} from '@isudio/ui';

const {$store, store, persistor} = setupStore();

export type iSudioProps =
  AppProps
  & {
  emotionCache?: EmotionCache;
};

const iSudio = (appProps: iSudioProps) => {
  const [mounted, setMounted] = useState(false);
  // const splineSettings = pages.home.spline.settings;

  _.windowResize();

  const {
    Component,
    pageProps,
    emotionCache
  } = appProps;

  useEffect(() => {
    setMounted(true);

    // if (!splineSettings?.url) return;
    // splinePreload(
    //   splineSettings.url
    // ).finally();

    const handler = (e: PointerEvent) => {
      const t = setTimeout(() => {
        if ($store.App.menuClicked$.value && !$store.App.showMenu$.value) {
          $store.App.mousePosition$.next({
            type: e.pointerType,
            x: e.clientX,
            y: e.clientY,
          });

          $store.App.showMenu$.next(true);
          $store.App.menuClicked$.next(false);
          clearTimeout(t);
        }
      });
    };

    window.addEventListener("pointerup", handler);
    return () => window.removeEventListener("pointerup", handler);
  }, []);

  const appContent = (
    <AppProviders emotionCache={emotionCache}>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <Menu />
      <SerwistProvider swUrl="/sw.js">
        <Component {...pageProps} />
      </SerwistProvider>
    </AppProviders>
  );

  return (
    <Provider store={store}>
      {!mounted ? (
        // On the server/build engine, bypass PersistGate so index.tsx evaluates
        // and exports its metadata tags safely into the raw HTML
        appContent
      ) : (
        // In the browser, maintain PersistGate to safely sync state before mounting
        <PersistGate
          loading={
            <div className="fixed inset-0 z-9999 bg-white dark:bg-bluegray-dark/85 flex items-center justify-center">
              <LoadingSpinner />
            </div>
          }
          persistor={persistor}
        >
          {appContent}
        </PersistGate>
      )}
    </Provider>
  );
};

export default iSudio;